import * as types from '../actions/action-types';

const INITIAL_STATE = {
    searchActive: false,
    searchLoading: false,
    searchResults: {
        data: [],
        number: 0
    }
};

//Search
export const getSearchResults = state => state.searchResults.data;
export const getSearchActive = state => state.searchActive;
export const getSearchResultsNumber = state => state.searchResults.number || 0;
export const getSearchLoading = state => state.searchLoading;

export default (state = INITIAL_STATE, action) => {
    if (action.type === types.TOGGLE_SEARCH) {
        return {
            ...state,
            searchActive: !state.searchActive,
            searchResults: {
                data: [],
                number: 0
            }
        };
    } else if (action.type === types.CLOSE_SEARCH) {
        return {
            ...state,
            searchActive: false,
            searchResults: {
                data: [],
                number: 0
            }
        };
    } else if (action.type === types.RESET_SEARCH_RESULTS) {
        return {
            ...state,
            searchResults: {
                data: [],
                number: 0
            }
        };
    } else if (action.type === types.FETCH_SEARCH_RESULTS) {
        return {
            ...state,
            searchLoading: true,
            searchResults: {
                data: [],
                number: 0
            }
        };
    } else if (action.type === types.FILTERED_SEARCH_RESULTS) {
        return {
            ...state,
            searchResults: {
                data: action.payload.data,
                number: (action.payload.data || []).length
            },
            searchLoading: false
        };
    }
    return state;
};



// WEBPACK FOOTER //
// ./src/reducers/global-search.js